import { gql } from 'apollo-angular';

export const BuyMovFragmentDoc = gql`
  fragment BuyMov on BuyMov {
    id
    employee {
      id
    }
    phoneDelivery
    buyItems {
      award {
        id
        name
      }
      quantity
    }
  }
`;

export const UpdateBuyDocument = gql`
  mutation UpdateBuy($id: String!, $data: UpdateBuyInput!) {
    updateBuy(id: $id, data: $data) {
      id
      status
    }
  }
`;

export const RemoveBuyFragmentDoc = gql`
  fragment RemoveExchanges on RemoveExchanges {
    message
  }
`;

export const RemoveBuyDocument = gql`
  mutation RemoveExchanges($data: RemoveExchangesInput!) {
    removeExchanges(data: $data) {
      ...RemoveExchanges
    }
  }
  ${RemoveBuyFragmentDoc}
`;

export const CreateExchangesDocument = gql`
  mutation CreateExchanges($data: CreateExchangesInput!) {
    createExchanges(data: $data) {
      ...Buy
    }
  }
  ${BuyMovFragmentDoc}
`;

export const SearchBuyDocument = gql`
  query SearchBuy($input: SearchBuyInput!) {
    searchBuy(data: $input) {
      ...Buy
    }
  }
  ${BuyMovFragmentDoc}
`;

export const SearchBuyProductDocument = gql`
  query SearchBuyProduct($input: SearchBuyProductInput!) {
    searchBuyProduct(data: $input) {
      ...Buy
    }
  }
  ${BuyMovFragmentDoc}
`;

export const CreateBuyMovDocument = gql`
  mutation CreateBuyMov($createBuyMovDto: CreateBuyMovDto!) {
    createBuyMov(createBuyMovDto: $createBuyMovDto) {
      ...BuyMov
    }
  }
  ${BuyMovFragmentDoc}
`;
